import { CheckCircle2 } from "lucide-react";
import EstimateWorkflow from "../components/EstimateWorkflow";
import SiteFooter from "../components/SiteFooter";

export default function EstimatePage() {
  return (
    <main data-testid="estimate-page">
      <section className="form-page container">
        <div className="form-page-intro"><p className="eyebrow coral-text">Vendre avec nous</p><h1>Connaître le potentiel<br /><span>de votre adresse.</span></h1><p>Quelques repères, puis un expert local vous recontacte pour une estimation vraiment juste.</p><div className="estimate-benefits"><span><CheckCircle2 size={17} /> Gratuit & sans engagement</span><span><CheckCircle2 size={17} /> Réponse sous 48h</span></div></div>
        <div className="multi-step-card" data-testid="estimate-form-card">
          <EstimateWorkflow />
        </div>
      </section>
      <SiteFooter />
    </main>
  );
}